<div class="bar">
    <div class="inner">
        <div class="start"><ng-content></ng-content></div>
        @if (showCancel()) {
            <button (click)="cancel.emit()" mat-stroked-button type="button">{{ cancelLabel() }}</button>
        }
        <button (click)="save.emit()" [disabled]="!canSave()" class="save" mat-flat-button type="button">
            {{ label() }}
        </button>
    </div>
</div>
